<template>
  <div class="social justify-content-center color-5 py-2">
    <a href="https://thenextdreamteam.com/es-es/" class="social__link font-1 color-5" target="_blank"
      aria-label="The Next Dream Team group website">
      The Next Dream Team
    </a>

    <a href="https://www.instagram.com/thenextdreamteam/" class="social__icon" target="_blank"
      aria-label="Follow The Next Dream Team on Instagram">
      <img class="social-media-logo" :src="require('../../assets/img/social-media-logos/instagram_64.png')" />
    </a>
  </div>
</template>

<script setup>
</script>

<style scoped>
.social {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  /* space-x-2 */
  font-size: 0.875rem;
  /* text-sm */
}

.social__link {
  font-weight: 500;
  text-decoration: none;
  color: inherit;
  transition: color 0.2s ease;
}

.social__icon {
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
}

.social__link:hover {
  color: #fb9a23;
  text-decoration: underline;
}

.social__icon:hover {
  transform: scale(1.1);
}
</style>
